function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortraitDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4583in",
    height: "1.4583in",
    viewBox: "0 0 37.042 37.042",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-152.1 -98.877)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.1,
    y: 98.877,
    width: 37.042,
    height: 37.042,
    ry: 2.0045,
    fill: "#b3a995",
    style: {
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7e7867"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m170.65 122.33a12.143 12.143 0 0 0-6.0999 1.6268 12.143 12.143 0 0 0-6.0715 10.517v1.4449h24.287v-1.4449a12.143 12.143 0 0 0-6.0715-10.517 12.143 12.143 0 0 0-6.0441-1.6268z",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.91,
    y: 117.66,
    width: 5.409,
    height: 7.7654,
    ry: 2.7045,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.35,
    y: 105.23,
    width: 14.547,
    height: 16.552,
    ry: 7.2734,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortraitDefault);
export default __webpack_public_path__ + "static/media/player-portrait-default.5835ee0b8a390f40543bcbdbf8b65baa.svg";
export { ForwardRef as ReactComponent };